import { Close, Send } from "@mui/icons-material";
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  useTheme,
  Box,
} from "@mui/material";
import { useState, useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { ModuleContext } from "../../context/ModuleContext";
import { UserModuleContext } from "../../context/UserModuleContext";
import { InputTheme } from "../../themes/InputTheme";

export const UpdateEmailForwarding = () => {
  const { setModule } = useContext(ModuleContext);
  const { userModule, setUserModule } = useContext(UserModuleContext);
  const { authState } = useOktaAuth();
  const outerTheme = useTheme();

  const [state, setState] = useState({
    error: null,
    waiting: false,
    emailForwarding:
      userModule.ADData["Email Forwarding"] ?? "",
    userComment: "",
    statusMessage: null,
  });

  const updateEmailForward = async () => {
    const { emailForwarding, userComment } = state;

    if (!userComment.trim()) {
      setState((prev) => ({
        ...prev,
        error: { message: "A comment must be provided" },
      }));
      return;
    }

    const formattedEmail = emailForwarding.startsWith("SMTP:")
      ? emailForwarding
      : `SMTP:${emailForwarding}`;

    setState((prev) => ({ ...prev, waiting: true }));

    try {
      const response = await fetch(
        `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/user/ad/attributes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: authState.accessToken.accessToken,
          },
          body: JSON.stringify({
            networkId: userModule.userData["Network ID"],
            dn: userModule.ADData["DN"],
            comment: userComment,
            attributes: {
              targetAddress: formattedEmail,
            },
            callerId: authState.accessToken.claims.sub,
          }),
        }
      );

      const result = await response.json();

      if (result.error) {
        setState((prev) => ({ ...prev, error: result.error, waiting: false }));
      } else {
        const updatedADData = {
          ...userModule.ADData,
          ["Email Forwarding"]: result.attributes.targetAddress,
        };

        setUserModule((prev) => ({ ...prev, ADData: updatedADData }));
        setState({
          error: null,
          waiting: false,
          emailForwarding: result.attributes.targetAddress,
          userComment: "",
          statusMessage: "Email Forwarding has been updated",
        });
      }
    } catch (err) {
      setState((prev) => ({
        ...prev,
        error: { message: err.message },
        waiting: false,
      }));
    }
  };

  const renderLoading = () => (
    <Box id="container-div" display="flex" justifyContent="center" alignItems="center">
      <CircularProgress style={{ color: "#A60F2D" }} size={100} thickness={10} />
    </Box>
  );

  const renderMessage = () => (
    <Box id="container-div" display="flex" justifyContent="center" alignItems="center">
      <p>{state.statusMessage}</p>
    </Box>
  );

  const renderError = () => (
    <Table>
      <TableBody>
        <TableRow>
          <TableCell align="center" style={{ backgroundColor: "#A60F2D", color: "white" }}>
            {state.error.message}
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );

  const renderForm = () => (
    <TableContainer>
      {state.error && renderError()}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" style={{ borderBottom: "none" }}>
              {`Update Email Forwarding for ${userModule.userData["Network ID"]}?`}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "none" }}>
              <TextField
                fullWidth
                label="Email Forwarding"
                value={state.emailForwarding}
                onChange={(e) => setState((prev) => ({ ...prev, emailForwarding: e.target.value }))}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: "none" }}>
              <TextField
                fullWidth
                required
                label="Comment"
                value={state.userComment}
                onChange={(e) => setState((prev) => ({ ...prev, userComment: e.target.value }))}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ borderBottom: "none" }}>
              <Button
                variant="contained"
                id="left-button"
                endIcon={<Send />}
                onClick={updateEmailForward}
              >
                Update Email Forwarding
              </Button>
            </TableCell>
            <TableCell style={{ borderBottom: "none" }}>
              <Button
                variant="contained"
                id="right-button"
                endIcon={<Close />}
                onClick={() => setModule((prev) => ({ ...prev, isVisible: false }))}
              >
                Cancel
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );

  return (
    <ThemeProvider theme={InputTheme(outerTheme)}>
      {state.waiting
        ? renderLoading()
        : state.statusMessage
        ? renderMessage()
        : renderForm()}
    </ThemeProvider>
  );
};